import { render } from "./permissionPage.vue?vue&type=template&id=0fb15460&scoped=true&ts=true"
import script from "./permissionPage.vue?vue&type=script&lang=ts"
export * from "./permissionPage.vue?vue&type=script&lang=ts"

import "./permissionPage.vue?vue&type=style&index=0&id=0fb15460&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fb15460"]])

export default __exports__